import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-show-dialog',
  templateUrl: './show-dialog.component.html',
  styleUrls: ['./show-dialog.component.scss']
})
export class ShowDialogComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ShowDialogComponent>) { }

  ngOnInit() {
  }

  dismiss() {
    this.dialogRef.close({
      dismissed: true
    });
  }

}
